import { ModelConstants } from '../model-constants';
import { IModel } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { AzureKeyVault } from './key-vault';
import { format } from '../../shared/utils/string.util';
import { validateAKVLinkedServiceReference } from '../../shared/utils/linkedservice-validation-util';

@Metamodel.model({
    name: ModelConstants.googleCloudStorageLinkedService,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.GoogleCloudStorage_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.GoogleCloudStorage_DisplayText)
    ]
})
export class GoogleCloudStorageLinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessKeyID
    })
    public accessKeyId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_SecretAccessKey,
        constraint: {
            validator: validateAKVLinkedServiceReference
        }
    })
    public secretAccessKey?: string | AzureKeyVault; // TODO: need a secure type to make sure this won't be exposed to customer.

    @Metamodel.attribute({
        display: stringResources.ModelName_ServiceUrl
    })
    public serviceUrl?: string = 'https://storage.googleapis.com'; // backend only accepts this value

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
